module.exports = __webpack_public_path__ + "static/img/AllInOne9.ec6f7b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AllInOne9.png
// module id = TFop
// module chunks = 2